"use client";

import useDiscount, { setGlobalDiscountMessageType } from "@/hooks/useDiscount";
import { getVariant } from "@/lib/bigcommerce/api/discount/utils";
import { useCouponApplication } from "@/hooks/useCouponApplication";
import { DiscountMessageType } from "@/lib/5874/types";
import { useCartContext } from "@/providers/CartContextProvider";
import styles from "./DiscountBanner.module.scss";
import Link from "@/components/UI/Link/Link";
import { StoreRegion } from "@/lib/_config/stores";

type Props = {
	messageSize: "LONG" | "SHORT";
	store: StoreRegion;
};

function DiscountBanner({ messageSize, store }: Props) {
	const { cart } = useCartContext();
	const {
		name,
		isValid,
		message,
		shouldShowMessage,
		promotionCode,
		messageType,
	} = useDiscount(messageSize);

	const { applyCoupon, isProcessing } = useCouponApplication(
		cart,
		promotionCode,
		store,
		{
			onSuccess: () => setGlobalDiscountMessageType("SUCCESS"),
			onFailure: () => setGlobalDiscountMessageType("FAILURE"),
			onNoCart: () => setGlobalDiscountMessageType("NO_CART"),
		},
	);

	if (
		!isValid ||
		!shouldShowMessage ||
		messageType === "SUCCESS" ||
		(cart &&
			cart.coupons.length > 0 &&
			cart.coupons.some((coupon) => coupon.code === promotionCode))
	) {
		return null;
	}

	const variantApplied = getVariant(messageType as DiscountMessageType);

	return (
		<section className={`${styles.bannerWrapper} ${styles[variantApplied]}`}>
			<Link
				href='#'
				onClick={applyCoupon}
				style={{ pointerEvents: isProcessing ? "none" : "auto" }}
			>
				{message}
			</Link>
		</section>
	);
}

export default DiscountBanner;
